import React, { Fragment } from "react";

const BannedUserItem = ({ banned_user, unBanUser }) => {
  return (
    <Fragment>
      <div className="report-item">
        <div className="user-section-alt grey">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div
                className={`avi-color-border ${
                  banned_user && banned_user.role === "innovator"
                    ? "green"
                    : banned_user && banned_user.role === "mentor"
                    ? "red"
                    : banned_user && banned_user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${banned_user.avatar}`}
                  className="friend-user-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span
                      className={`${
                        banned_user && banned_user.role === "innovator"
                          ? "green"
                          : banned_user && banned_user.role === "mentor"
                          ? "red"
                          : banned_user && banned_user.role === "employer"
                          ? "blue"
                          : ""
                      } name-font`}
                    >
                      {banned_user.channelid}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {banned_user.firstname} {banned_user.lastname}
                  </li>
                  <li className="user-online-item">{banned_user.jobtitle}</li>
                  <li className="user-online-item">
                    {banned_user.location && banned_user.location.state},{" "}
                    {banned_user.location && banned_user.location.country}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                onClick={() => unBanUser(banned_user.channelid)}
                className={`setting-friend-button ${
                  banned_user && banned_user.role === "innovator"
                    ? "background-green"
                    : banned_user && banned_user.role === "mentor"
                    ? "background-red"
                    : banned_user && banned_user.role === "employer"
                    ? "background-blue"
                    : ""
                }`}
              >
                <i className="fa-solid fa-handcuffs mx-5"></i>
                Unban
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BannedUserItem;
